import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import {
  Flex,
  Heading,
  Box,
  Button,
  HStack,
} from '@chakra-ui/react'

import SettingsBreadcrumb from '../../../components/SettingsBreadcrumb';
import TabelaTipoMidia from './tabela-tipo-midia';
import * as api from '../../../api/tipoMidia';
import Paginacao from '../../../components/common/paginacao/paginacao';

const GerenciarTipoMidia = () => {
  const [tipoMidias, setTipoMidias] = useState<any[]>([]);
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate()

  useEffect(() => {
    const fetchTipoMidias = async () => {
      setLoading(true);
      try {
        const data = await api.listarTipoMidia(paginaAtual, itemsPerPage);

        setTipoMidias(data.formatoArquivos.map((tipoMidia: any) => ({
          codMidia: tipoMidia.codMidia,
          dscMidia: tipoMidia.dscMidia,
        })));
        setTotalPages(data.totalPaginas);

      } catch (error) {
        console.error('Erro ao buscar tipo de mídias:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchTipoMidias();
  }, [paginaAtual, itemsPerPage]);

  return (
    <Flex p="40px" bgColor="#fafafa" direction="column" w="100%">
      <SettingsBreadcrumb />
      <Heading
        mt="30px"
        fontWeight="600"
        fontSize="21px"
        color="#6F6F6F"
        w="100%"
      >
        Gerenciar Tipo de Mídia
      </Heading>

      <Box m="40px 0" w="100%">
        <HStack spacing={5}>
          <Button
            color="#fff"
            bgColor="#1789FC"
            _hover={{
              bgColor: "#1468C9"
            }}
            onClick={() => navigate('inserir-tipo-midia')}
          >
            Adicionar Novo Tipo de Mídia
          </Button>
        </HStack>
      </Box>

      <Box>
        <TabelaTipoMidia 
          listaTipoMidia={tipoMidias} 
          listaVazia="Nenhum dado disponível." 
          loading={loading}
        />
      </Box>

      <Paginacao 
        paginaAtual={paginaAtual} 
        totalPages={totalPages} 
        onPageChange={setPaginaAtual}
      />
    </Flex>
  )
}

export default GerenciarTipoMidia
